module.exports = __webpack_public_path__ + "images/iphone/home-contacts.png";